import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import FinancialCard from "../../components/financial/FinancialCard";
import {getCardsData} from "../../models/financialReportModel";
import {
    fetchFinancialReport,
    resetMonthFilterStatus, setFormMonthRange, setMonthFilterStatus, setRangeMonth,
} from "../../store/financial-report-slice";
import MonthFilter from "../../components/financial/MonthFilter";
import Stack from "../../components/ui/Stack";
import {getMonthRange} from "../../components/Utility";

const FinancialReport = () => {
    const dispatch = useDispatch();
    const {
        items,
        fetchStatus,
        monthFilterStatus,
        monthRange: monthRangeValue,
        formRange,
        error
    } = useSelector((state) => state.financial);
    const userRole = useSelector((state) => state.auth.selectedRole);
    const [formData, setFormData] = useState({start: "", end: ""});
    const [errors, setErrors] = useState({start: "", end: ""});

    useEffect(() => {
        const today = new Date();
        const defaultRange = getMonthRange(today.getFullYear(), today.getMonth(), "+05:30");

        let initialRange;

        if (monthFilterStatus && monthRangeValue) {
            initialRange = monthRangeValue;
        } else if (formRange.start && formRange.end) {
            initialRange = formRange;
        } else {
            initialRange = {
                start: defaultRange.start.slice(0, 10),
                end: defaultRange.end.slice(0, 10),
            };
        }

        setFormData(initialRange);

        dispatch(
            fetchFinancialReport({
                ...userRole,
                formData: initialRange,
            })
        );
    }, [dispatch, userRole, monthFilterStatus, monthRangeValue, formRange]);

    const handleMonthChange = (range) => {
        const updatedDateRange = {
            start: range.start.slice(0, 10),
            end: range.end.slice(0, 10),
        };
        dispatch(setRangeMonth(updatedDateRange))
        dispatch(setMonthFilterStatus());
    };

    const handleFormChange = (name, value) => {
        setFormData((prev) => ({...prev, [name]: value}));
    };

    const validateField = (id, value) => {
        let error = "";
        const trimmed = typeof value === "string" ? value.trim() : value;
        if (id === "start" && !trimmed) error = "Start date is required";
        if (id === "end" && !trimmed) error = "End date is required";
        setErrors((prev) => ({...prev, [id]: error}));
        return error === "";
    };

    const handleBlur = (e) => validateField(e.target.id, e.target.value);

    const validateForm = () =>
        Object.entries(formData).every(([key, value]) => validateField(key, value));

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        dispatch(setFormMonthRange(formData));
        dispatch(resetMonthFilterStatus());
    };

    const cardsData = getCardsData({data: items});

    return (
        <>
            <SubHeader title="Financial Report"/>
            {fetchStatus === "loading" && <p>Loading...</p>}
            {fetchStatus === "failed" && <h6 className="text-danger">{error}</h6>}
            {fetchStatus === "success" && (
                <>
                    <form onSubmit={handleSubmit}>
                        <Stack className="justify-content-between" style ={{marginTop: "-20px"}}>
                            <MonthFilter timezoneOffset="+05:30" onMonthChange={handleMonthChange}/>
                            <div className="row mb-5">
                                <div className="col-md-4 col-lg-5">
                                    <div className="form-group">
                                        <label className="form-label opacity-75">Start Date</label>
                                        <input
                                            className="form-control"
                                            id="start"
                                            name="start"
                                            type="date"
                                            value={formData.start}
                                            onBlur={handleBlur}
                                            onChange={(e) => handleFormChange("start", e.target.value)}
                                        />
                                        {errors.start && <div className="invalid-feedback d-block">{errors.start}</div>}
                                    </div>
                                </div>

                                <div className="col-md-4 col-lg-5">
                                    <div className="form-group">
                                        <label className="form-label opacity-75">End Date</label>
                                        <input
                                            className="form-control"
                                            id="end"
                                            name="end"
                                            type="date"
                                            value={formData.end}
                                            onBlur={handleBlur}
                                            onChange={(e) => handleFormChange("end", e.target.value)}
                                        />
                                        {errors.end && <div className="invalid-feedback d-block">{errors.end}</div>}
                                    </div>
                                </div>

                                <div className="col-md-4 col-lg-2">
                                    <div className="form-group">
                                        <label className="form-label opacity-75 d-block">&nbsp;</label>
                                        <button
                                            type="submit"
                                            className="btn bg-primary bg-opacity-15 bg-opacity-25-hover py-2 px-4 fw-medium border-0 me-2 fs-sm"
                                        >
                                            Submit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </Stack>
                    </form>

                    <FinancialCard data={cardsData}/>
                </>
            )}
        </>
    );
};

export default FinancialReport;
